import gql from 'graphql-tag';

export const SUBSCRIBE_TO_UPDATED_PEBBLE = gql`
  subscription {
    pebbleUpdated {
      updatedAssigneeId
    }
  }
`;
